module.exports = __webpack_public_path__ + "img/product-showcase-gallery-04.6ce5e975.jpg";